const ITEMS = [
  "XAUUSD SPOT",
  "CONFLUENCE ZONES",
  "RISK DISCIPLINE",
  "INSTITUTIONAL ORDER BLOCKS",
  "NO SIGNALS",
  "INDEPENDENT TRADING",
  "ATLAS SYSTEM",
  "MARKET PSYCHOLOGY",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-line/70 py-5 overflow-hidden mask-fade-x bg-panel/40" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee-slow">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8">
                <span className="font-display font-bold text-sm sm:text-base tracking-[0.25em] text-gold/35 whitespace-nowrap uppercase">
                  {item}
                </span>
                <span className="text-gold/25 text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
